export const CLIENT_ID = '684C957199C3BE6C153A778D1986032B';
export const APPLICATION_JSON = 'application/json';
export const APPLICATION_FORM = 'application/x-www-form-urlencoded';
export const GET = 'GET';
export const POST = 'POST';
export const INCLUDE = 'include';
export const CAR = 'car';
export const EWP_BOOKING_SERVICE_TOGGLE = 'ewpBookingServiceEnabled';
export const EWP_CANCELLATION_SERVICE_TOGGLE = 'ewpCancelServiceEnabled';
export const CLICK_TO_CHAT_ENABLED = 'clickToChatEnabled';
export const ROOT_LOAD_LOCALES_MARKETENABLEMENTS = 'ROOT_LOAD_LOCALES_MARKETENABLEMENTS';
export const MODULENAME = 'axp-manage-bookings-root';
export const ROOT_READ_USER_SESSIONS = 'ROOT_READ_USER_SESSIONS';
export const ROOT_ERROR_BOUNDARY = 'ROOT_ERROR_BOUNDARY';
export const ROOT_HOME_PAGE = 'ROOT_HOME_PAGE';
export const E1 = 'e1';
export const S1 = 's1';
export const P1 = 'p1';
export const T1 = 't1';
export const E2 = 'e2';
export const S2 = 's2';
export const P2 = 'p2';
export const T2 = 't2';
export const E3 = 'e3';
export const S3 = 's3';
export const P3 = 'p3';
export const T3 = 't3';
export const HOTEL = 'hotel';
export const V2 = 'v2';
